<script>

import { Overlay } from '../../'
import { drawIndicatorPlot } from '../../workspace/indicator-plots.mjs'

export default {
    name: 'Histogram',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad',
                version: '1.0.0',
                desc: 'Histogram plot',
                preset: {
                    name: 'Histogram',
                    side: 'offchart',
                    settings: {
                        lineWidth: 2
                    }
                }
            }
        },

        draw(ctx) {
            drawIndicatorPlot(ctx, this.$props.data, this.$props.layout, this.sett, 0, {color:this.color,width:this.line_width,style:'histogram'})
        },
        use_for() { return ['Histogram'] },
        legend(values) {
            let x = values[1]
            if (typeof x === "number") {
                x = x.toFixed(Math.abs(x) > 0.001 ? 4 : 8)
            }
            return [{
                value: x,
                color:values[2] || this.color
            }]
        },
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            return this.$props.settings
        },
        line_width() {
            return this.sett.lineWidth || 2
        },
        color() {
            const n = this.$props.num % 5
            return this.sett.color || this.COLORS[n]
        }
    },
    data() {
        return {
            COLORS:
            [
                '#888888', '#42b28a', '#5691ce', '#612ff9',
                '#d50b90', '#ff2316'
            ]
        }
    }

}
</script>
